import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { navigation } from '../../pages/navigation';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';


@Injectable()
export class MenuService {

    constructor( private http: HttpClient) {}

    getMenu(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.BACKEND}acl/menu`)
        .pipe(
            map((data: any) => data.response)
        );
    }


    /* getMenu(): Promise<any> {
        return new Promise((resolve, reject) => {
            setInterval(data =>{
                of(navigation).subscribe(response =>{
                    resolve(response);
                }, reject)
            },5000)
          });
    } */

}
